var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{staticClass:"wt-router-link",class:_vm.routerLinkStyleClasses,attrs:{"to":{ name: _vm.to, params: _vm.params }}},[_vm._t("default"),_vm._t("icon"),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }